import {atom, selector} from "recoil";

export interface StateLoading {
    models: boolean
    sizes: boolean
    data: boolean
    submit: boolean
}

export const stateLoading = atom<StateLoading>({
    key: 'loading',
    default: {
        models: true,
        sizes: true,
        data: true,
        submit: false,
    },
});

export const stateLoadingAll = selector<boolean>({
    key: 'isLoadingALl',
    get: ({get}) => {
        const loadings = get(stateLoading);

        return loadings.models || loadings.sizes || loadings.data;
    },
});


export const stateLoadingModels = selector<boolean>({
    key: 'isLoadingModels',
    get: ({get}) => {
        const loadings = get(stateLoading);

        return loadings.models;
    },
});

export const stateLoadingSizes = selector<boolean>({
    key: 'isLoadingSizes',
    get: ({get}) => {
        const loadings = get(stateLoading);

        return loadings.models || loadings.sizes;
    },
});

export const stateLoadingData = selector<boolean>({
    key: 'isLoadingData',
    get: ({get}) => {
        const loadings = get(stateLoading);

        return loadings.data;
    },
});

export const stateLoadingSubmit = selector<boolean>({
    key: 'isLoadingSubmit',
    get: ({get}) => {
        const loadings = get(stateLoading);

        return loadings.submit;
    },
});
